export default "__VITE_ASSET__CaDEhfzD__"